"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Dialog = _interopRequireDefault(require("@mui/material/Dialog/Dialog.js"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _Colors = _interopRequireDefault(require("../../styles/Colors"));

var _XIcon = _interopRequireDefault(require("../../assets/Icons/XIcon"));

var _Button = _interopRequireDefault(require("../Button"));

var _excluded = ["title", "titleCenter", "isSeparatorHidden", "confirmBtn", "cancelBtn", "isCustom"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _makeStyles.default)({
  headerContainer: {
    padding: '24px 32px',
    position: 'relative'
  },
  title: {
    width: 'calc(100% - 30px)',
    textTransform: 'uppercase',
    letterSpacing: '0.7px',
    fontFamily: 'Oswald',
    fontWeight: 500,
    fontSize: '22px',
    color: _Colors.default.textElementGrey,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&.titleCenter': {
      textAlign: 'center'
    }
  },
  closeIcon: {
    position: 'absolute',
    right: '24px',
    top: 'calc(50% - 16px)',
    cursor: 'pointer'
  },
  separator: {
    border: 'none',
    borderTop: "1px solid ".concat(_Colors.default.lightGrey),
    margin: '0'
  },
  btnContainer: {
    padding: '24px 32px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    '&.onlyConfirm': {
      justifyContent: 'center'
    }
  },
  cancelBtn: {
    paddingRight: '5px'
  },
  modalBody: {
    paddingRight: '5px',
    scrollbarWidth: 'thin',
    scrollbarColor: 'blue orange',
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      width: '4px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: _Colors.default.secondaryGrey,
      opacity: 0.5,
      borderRadius: 1
    }
  }
});

var Modal = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var title = _ref.title,
      titleCenter = _ref.titleCenter,
      isSeparatorHidden = _ref.isSeparatorHidden,
      confirmBtn = _ref.confirmBtn,
      cancelBtn = _ref.cancelBtn,
      isCustom = _ref.isCustom,
      rest = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();
  var onClose = rest.onClose,
      children = rest.children;
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, _extends({
    ref: ref
  }, rest), isCustom ? children : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.headerContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classes.title, " ").concat(titleCenter ? 'titleCenter' : '')
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.closeIcon,
    onClick: onClose,
    role: "none"
  }, /*#__PURE__*/_react.default.createElement(_XIcon.default, {
    fill: "black"
  }))), /*#__PURE__*/_react.default.createElement("hr", {
    className: classes.separator
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.modalBody
  }, children), confirmBtn && !isSeparatorHidden && /*#__PURE__*/_react.default.createElement("hr", {
    className: classes.separator
  }), confirmBtn && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classes.btnContainer, " ").concat(cancelBtn ? '' : 'onlyConfirm')
  }, cancelBtn && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.cancelBtn
  }, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({}, cancelBtn, {
    intent: cancelBtn.intent || 'tertiary',
    label: cancelBtn.label || 'Cancel'
  }))), /*#__PURE__*/_react.default.createElement(_Button.default, _extends({}, confirmBtn, {
    intent: confirmBtn.intent || 'primary',
    label: confirmBtn.label || 'Confirm'
  }))))));
});

var _default = Modal;
exports.default = _default;